import { C } from "./const";
import { SERVICES } from "./IntroServices";
import Logo from "./Logo";

const IntroFooter = () => {
    return (
        <footer style={{ background: C.primaryDark, padding: "52px 24px 28px" }}>
            <div style={{ maxWidth: 1200, margin: "0 auto" }}>
                <div
                    className="grid-3"
                    style={{
                        display: "grid",
                        gridTemplateColumns: "2fr 1fr 1fr",
                        gap: 40,
                        marginBottom: 40,
                    }}
                >
                    {/* Brand */}
                    <div>
                        <Logo style={{ display: "flex", alignItems: "center", gap: 10 }} />
                        <p style={{ color: "rgba(255,255,255,.6)", fontSize: 13, lineHeight: 1.85, maxWidth: 320 }}>
                            با بیش از ۱۳ سال تجربه، ما متعهد به ارائه بهترین خدمات بیمه‌ای
                            با بالاترین استانداردهای کیفی هستیم.
                        </p>
                    </div>

                    {/* Quick links */}
                    <div>
                        <h4 style={{ color: C.accent, fontWeight: 700, fontSize: 14, marginBottom: 18 }}>
                            دسترسی سریع
                        </h4>
                        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                            {[
                                ["خدمات بیمه", "/#services"],
                                ["درباره ما", "/#about"],
                                ["نظرات مشتریان", "/#testimonials"],
                                ["سوالات متداول", "/#faq"],
                                ["تماس با ما", "/#contact"],
                            ].map(([label, href]) => (
                                <a
                                    key={label}
                                    href={href}
                                    className="hov-nav"
                                    style={{ color: "rgba(255,255,255,.65)", fontSize: 13 }}
                                >
                                    {label}
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Services */}
                    <div>
                        <h4 style={{ color: C.accent, fontWeight: 700, fontSize: 14, marginBottom: 18 }}>
                            خدمات ما
                        </h4>
                        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                            {SERVICES.map((s) => (
                                <a
                                    key={s.title}
                                    href="/#contact"
                                    className="hov-nav"
                                    style={{ color: "rgba(255,255,255,.65)", fontSize: 13 }}
                                >
                                    {s.icon} {s.title}
                                </a>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Divider */}
                <div style={{ borderTop: "1px solid rgba(255,255,255,.12)", paddingTop: 24 }}>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: 12,
                        }}
                    >
                        <p style={{ color: "rgba(255,255,255,.45)", fontSize: 12 }}>
                            © ۱۴۰۵ نمایندگی بیمه پارسیان — تمامی حقوق محفوظ است
                        </p>
                        <div style={{ display: "flex", gap: 16 }}>
                            {["حریم خصوصی", "شرایط استفاده", "نقشه سایت"].map((item) => (
                                <a
                                    key={item}
                                    href="#"
                                    style={{ color: "rgba(255,255,255,.4)", fontSize: 12 }}
                                >
                                    {item}
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}







export default IntroFooter;